// src/pages/HomePage.tsx
/*
import { useEffect, useState } from "react";
import api from "../services/api";

import Navbar from "../components/Navbar";
import HeroCarousel, { Slide } from "../components/HeroCarousel";
import CategoryFilter from "../components/CategoryFilter";
import ProductGrid from "../components/ProductGrid";
import ProductInfoModal from "../components/ProductInfoModal";
import Cart from "../components/sales/Cart";
import checkout from "../components/sales/Checkout";
import Footer from "../components/Footer";

import { Product } from "../types/product";
import { SaleItem } from "../types/sale";
import { PaginatedResponse } from "../types/api";
// ...
import Checkout from "../components/sales/Checkout"; // ✅ import as component



  
export default function HomePage() {
  const [products, setProducts] = useState<Product[]>([]);
  const [slides, setSlides] = useState<Slide[]>([]);
  const [cart, setCart] = useState<SaleItem[]>([]);
  const [category, setCategory] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  // ✅ Pagination + sorting states
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<PaginatedResponse<Product> | null>(null);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadProducts = async () => {
      try {
        setLoading(true);

        const res = await api.get<PaginatedResponse<Product>>("/products", {
          params: {
            page,
            sort: sortField,
            order: sortOrder,
            category: category || undefined,
          },
          signal: controller.signal,
        });

        setProducts(res.data.data);
        setPagination(res.data);
      } catch (err) {
        console.error("Failed to load products", err);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
    return () => controller.abort();
  }, [category, page, sortField, sortOrder]);

  useEffect(() => {
    const banners = ["banner1.jfif", "banner2.jfif"];
    setSlides(
      banners.map((file, i) => ({
        id: i + 1,
        title: "Welcome to BIS - Butter Information System",
        subtitle: "Fast & Reliable Butter Advisory / Assisted Selling system",
        image: `/banners/${file}`,
      }))
    );
  }, []);

  const handleBuy = (item: SaleItem) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.product_id === item.product_id);
      if (existing) {
        return prev.map((i) =>
          i.product_id === item.product_id
            ? { ...i, quantity: i.quantity + 1 }
            : i
        );
      }
      return [...prev, item];
    });
  };

  const handleSort = (field: string) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
    setPage(1); // reset to first page
  };

  return (
    <>
      <Navbar />

      <div className="col-md-12 d-flex justify-content-center">
        {slides.length > 0 && <HeroCarousel slides={slides} width="95%" height="400px" />}
      </div>

      <main className="container-fluid py-5 bg-light">
        <div className="px-4">
          <CategoryFilter
            value={category}
            onChange={setCategory}
            onFilter={(cat) => {
              setCategory(cat);
              setPage(1); // reset page when category changes
            }}
          />

          {loading && (
            <div className="d-flex align-items-center mt-3">
              <div className="spinner-border text-primary me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <span className="text-info">Loading products…</span>
            </div>
          )}

          <ProductGrid
  products={products}
  loading={loading}
  onBuy={handleBuy}
  sortField={sortField}
  sortOrder={sortOrder}
  onSort={handleSort}
  onQuickView={(p) => setSelectedProduct(p)} // ✅ fix
/>

{selectedProduct && (
  <ProductInfoModal
    product={selectedProduct}
    show={true}
    onClose={() => setSelectedProduct(null)}
  />
)}



          {/ ✅ Pagination controls for products /}
          {pagination && (
            <nav>
              <ul className="pagination">
                {Array.from({ length: pagination.last_page }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${page === i + 1 ? "active" : ""}`}
                  >
                    <button className="page-link" onClick={() => setPage(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>
      </main>

      <section className="container py-5">
        <div className="row g-4">
          <div className="col-md-4 ms-auto">
            <Cart cart={cart} setCart={setCart} />
            {cart.length > 0 && (
              <button
                className="btn btn-success w-100 mt-3"
                onClick={() => checkout(cart)}
              >
                Checkout
              </button>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

*/
// src/pages/HomePage.tsx
import { useEffect, useState } from "react";
import api from "../services/api";

import Navbar from "../components/Navbar";
import HeroCarousel, { Slide } from "../components/HeroCarousel";
import CategoryFilter from "../components/CategoryFilter";
import ProductGrid from "../components/ProductGrid";
import ProductInfoModal from "../components/ProductInfoModal";
import Cart from "../components/sales/Cart";
import Checkout from "../components/sales/Checkout"; // ✅ use component
import Footer from "../components/Footer";

import { Product } from "../types/product";
import { SaleItem } from "../types/sale";
import { PaginatedResponse } from "../types/api";

export default function HomePage() {
  const [products, setProducts] = useState<Product[]>([]);
  const [slides, setSlides] = useState<Slide[]>([]);
  const [cart, setCart] = useState<SaleItem[]>([]);
  const [category, setCategory] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  // ✅ Pagination + sorting states
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<PaginatedResponse<Product> | null>(null);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadProducts = async () => {
      try {
        setLoading(true);

        const res = await api.get<PaginatedResponse<Product>>("/products", {
          params: {
            page,
            sort: sortField,
            order: sortOrder,
            category: category || undefined,
          },
          signal: controller.signal,
        });

        setProducts(res.data.data);
        setPagination(res.data);
      } catch (err) {
        console.error("Failed to load products", err);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
    return () => controller.abort();
  }, [category, page, sortField, sortOrder]);

  useEffect(() => {
    const banners = ["banner1.jfif", "banner2.jfif"];
    setSlides(
      banners.map((file, i) => ({
        id: i + 1,
        title: "Welcome to BIS - Butter Information System",
        subtitle: "Fast & Reliable Butter Advisory / Assisted Selling system",
        image: `/banners/${file}`,
      }))
    );
  }, []);

  const handleBuy = (item: SaleItem) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.product_id === item.product_id);
      if (existing) {
        return prev.map((i) =>
          i.product_id === item.product_id
            ? { ...i, quantity: i.quantity + 1 }
            : i
        );
      }
      return [...prev, item];
    });
  };

  const handleSort = (field: string) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
    setPage(1); // reset to first page
  };

  return (
    <>
      <Navbar />

      <div className="col-md-12 d-flex justify-content-center">
        {slides.length > 0 && (
          <HeroCarousel slides={slides} width="95%" height="400px" />
        )}
      </div>

      <main className="container-fluid py-5 bg-light">
        <div className="px-4">
          <CategoryFilter
            value={category}
            onChange={setCategory}
            onFilter={(cat) => {
              setCategory(cat);
              setPage(1); // reset page when category changes
            }}
          />

          {loading && (
            <div className="d-flex align-items-center mt-3">
              <div className="spinner-border text-primary me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <span className="text-info">Loading products…</span>
            </div>
          )}

          <ProductGrid
            products={products}
            loading={loading}
            onBuy={handleBuy}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={handleSort}
            onQuickView={(p) => setSelectedProduct(p)}
          />

          {selectedProduct && (
            <ProductInfoModal
              product={selectedProduct}
              show={true}
              onClose={() => setSelectedProduct(null)}
            />
          )}

          {/* ✅ Pagination controls for products */}
          {pagination && (
            <nav>
              <ul className="pagination">
                {Array.from({ length: pagination.last_page }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${page === i + 1 ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>
      </main>

      <section className="container py-5">
        <div className="row g-4">
          <div className="col-md-4 ms-auto">
            <Cart cart={cart} setCart={setCart} />
{cart.length > 0 && (
  <>
    {/* ✅ render component */}
    <Checkout cart={cart} setCart={setCart} />
  </>
)}

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
